import { Component, OnInit, Output, EventEmitter, OnDestroy, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedContainer } from '../../../shared.container';
import { Observable, Subscription } from 'rxjs';
import { FacebookLoginProvider, GoogleLoginProvider } from 'angularx-social-login';
import { SocialAuthService, SocialUser } from 'angularx-social-login';
import { DashboardService } from '../../../../core/services/dashboard.service';
import { AuthService as BasicAuth } from '../../../../core/services/auth.service';
import { IUser } from '../../../../core/models/user.model';
import { Subject } from 'rxjs';
import { isLoadingState } from '../../../../core/store/general/selectors';
import { Store } from '@ngrx/store';
import { Sandbox } from '../../../../core/facade/sandbox';
import { GeneralState } from '../../../../core/store/general/state';
import { environment } from '../../../../../environments/environment';
import { AuthState } from '../../../../core/store/auth/auth.reducer';
import { Angulartics2 } from 'angulartics2';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SearchEngineService } from '../../../../core/services/search-engine.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { gsap } from 'gsap';


declare const fbq: any;

@Component({
  selector: 'app-loginpage',
  templateUrl: 'login-page.html',
  styleUrls: ['login-page.scss']
})

export class LoginPageComponent extends Sandbox implements OnInit, AfterViewInit, OnDestroy {

  isLogIn: boolean;
  isSignUp: boolean;
  isForgotPasswd: boolean;

  public isLoggedIn$;
  public isLoading$;
  public webSocket;
  public userId;
  adminUrl = environment.adminUrl;

  isSignUpNormal: Boolean = false;

  private userEmail: string;
  private userPasswd: string;
  private userPasswdConfirm: string;

  user = {
    email: null,
    passwd: null
  };

  userSignup = { email: null, name: null, surname: null, passwd: null };

  confirmedNewPassword;
  private fbuser: SocialUser;
  private loggedIn: boolean;
  forgotPassword = false;
  fromSocialSignUp: Boolean = false;
  loginSuccess: Boolean = false;

  subscription: Subscription;
  loginInterval: any;

  afterFillingRequest: boolean;
  requestForSearch: any;

  userEmailfg: string;
  userPasswdfg: string;
  userPasswdfgRetype: string;
  showDetailsPasswd: Boolean = false;
  lowerCaseCriteriaMsg: String = 'Your password must contain at least one lower case character';
  upperCaseCriteriaMsg: String = 'Your password must contain at least one upper case character';
  minCharsCriteriaMsg: String = 'Your password must be at least 8 characters long';
  digitsCriteriaMsg: String = 'Your password must contain at least one digit';

  localSocialUrl: String = 'https://localhost:8181/webresources/frontend/entity.users/loginGoogle';
  devSocialUrl: String = 'https://vvdo-dev.vervendo.com/webresources/frontend/entity.users/loginGoogle';
  prodSocialUrl: String = 'https://admin.vervendo.com/webresources/frontend/entity.users/loginGoogle';

  deviceType: string;

  @Output() sendResult: EventEmitter<any> = new EventEmitter();
  @Output() sendSignup: EventEmitter<any> = new EventEmitter();
  @Output() socialLogin: EventEmitter<any> = new EventEmitter();
  @Output() sendNewPassword: EventEmitter<any> = new EventEmitter();

  constructor(protected router: Router, private angulartics2: Angulartics2, protected sharedContainer: SharedContainer,
    private route: ActivatedRoute, private auth: SocialAuthService, private spinner: NgxSpinnerService,
    private http: HttpClient,
    private dashboardService: DashboardService, private basicAuth: BasicAuth, protected appState$: Store<AuthState>,
    public generalState$: Store<GeneralState>, private deviceInfo: DeviceDetectorService, private searchService: SearchEngineService) {
    super(appState$, generalState$, basicAuth, router, auth);

    this.isLoggedIn$ = this.loggedUser$;
    this.generalState$.select(isLoadingState).subscribe(arg => this.isLoading$ = arg);
    this.sharedContainer.initializeWebSocketConnection();

  }

  public userLoggedInSub = new Subject<boolean>();
  public userLoggedIn$ = this.userLoggedInSub.asObservable();

  ngOnInit() {
    this.spinner.hide();
    if (this.deviceInfo.isDesktop()) {
      this.deviceType = 'desktop';
    } else if (this.deviceInfo.isMobile()) {
      this.deviceType = 'mobile';
    } else if (this.deviceInfo.isTablet()) {
      this.deviceType = 'tablet';
    }
    this.route.queryParams.subscribe(params => {
      let intent = params.intent;
      if (!intent) {
        intent = 'login';
      }
      if (intent === 'login') {
        this.isLogIn = true;
        this.isSignUp = false;
        this.isForgotPasswd = false;
      } else if (intent === 'signup') {
        this.isSignUp = true;
        this.isLogIn = false;
        this.isForgotPasswd = false;
      } else {
        this.isForgotPasswd = true;
        this.isLogIn = false;
        this.isSignUp = false;
      }
      // analytics START
      fbq('track', intent, {});
      // analytics END
      if (params.checkInDate || params.checkOutDate || params.adults) {
        this.afterFillingRequest = true;
        this.requestForSearch = {
          checkInDate: params.checkInDate,
          checkOutDate: params.checkOutDate,
          adults: params.adults,
          children: params.children,
          rooms: params.rooms,
          sendRequests: params.sendRequests,
          experiences: params.experiences,
          personalrequest: params.personalrequest,
          requestexpires: 13,
          region: params.region
        };
      } else {
        this.afterFillingRequest = false;
      }
      if (params.userid) {
        const loggedInUser: IUser = {
          email: params.email,
          id: parseInt(params.userid, 10),
          name: params.name,
          surname: params.surname,
          username: params.email
        };
        try {
          if (this.sharedContainer.userCountry === undefined) {
            this.searchService.getTravellerLocation().subscribe(response => {
              this.searchService.getCountry(response.ip).subscribe(responsee => {
                this.sharedContainer.userCountry = responsee.country_name;
                this.handleProcessAfterAuth(loggedInUser);
              });
            });
          } else {
            this.handleProcessAfterAuth(loggedInUser);
          }
        } catch (e) {
          this.handleProcessAfterAuth(loggedInUser);
        }
      }
      this.checkUserNavLogErr();
    });

    this.auth.initState.subscribe(() => { }, console.error, () => { console.log('all providers are ready'); });

  }

  ngAfterViewInit() {
    this.playAnimationLogin();
  }

  ngOnDestroy() {
    this.fbuser = null;
  }

  checkUserNavLogErr() {
    try {
      const user = localStorage.getItem('user');
      const userid = JSON.parse(user).id;
      this.dashboardService.getLastRequestsByUserDesc(userid, 1).subscribe(data => {
        if (data.length > 0) {
          const fromDate = new Date(data[0].fromDate);
          const toDate = new Date(data[0].toDate);
          const fromDateFormatted = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate();
          const toDateFormatted = toDate.getFullYear() + '-' + (toDate.getMonth() + 1) + '-' + toDate.getDate();
          this.spinner.hide();
          this.router.navigate(['results/'], {
            queryParams: {
              checkInDate: fromDateFormatted,
              checkOutDate: toDateFormatted,
              adults: data[0].noOfAdults,
              children: data[0].noOfChildren,
              'personalrequest': data[0].personalRequest,
              'rooms': parseInt(data[0].noOfRooms, 10),
              'requestId': parseInt(data[0].id, 10),
              region: data[0].destination,
              origin: this.sharedContainer.userCountry,
              sortby: 'high_to_low',
              offers: 0
            }
          });
        } else {
          this.spinner.hide();
          this.router.navigate(['search/']);
        }
      });
    } catch (error) {
      console.error('Exception: ' + error);
    }
  }

  showPassword() {
    if (this.isSignUp) {
      const field = <HTMLInputElement>document.getElementById('pass');
      const field2 = <HTMLInputElement>document.getElementById('passc');
      if (field.type === 'password') {
        field.type = 'text';
        field2.type = 'text';
      } else {
        field.type = 'password';
        field2.type = 'password';
      }
    } else if (this.isLogIn) {
      const field = <HTMLInputElement>document.getElementById('passl');
      if (field.type === 'password') {
        field.type = 'text';
      } else {
        field.type = 'password';
      }
    }
  }

  submitReset() {
    // execute password update
    if (this.userEmailfg != null && this.userEmailfg.length > 5) {
      this.onChangePassword();
    } else {
      alert('Please enter a valid email');
    }
  }

  onChangePassword() {
    const genPassWd = Math.random().toString(36).slice(-8);
    this.basicAuth.forgotPassword(this.userEmailfg, genPassWd).subscribe((result) => {
      alert('Your password has been reset! Please check your email');
      this.router.navigate(['login-page'], { queryParams: { intent: 'login' } });
      this.isSignUpNormal = false;
      this.isLogIn = true;
      this.isForgotPasswd = false;
    });
  }

  signUpNormal() {
    if (this.isSignUpNormal) {
      this.isSignUpNormal = false;
    } else {
      this.isSignUpNormal = true;
    }
  }

  forgotBtn() {
    this.isLogIn = false;
    this.isSignUp = false;
    this.isForgotPasswd = true;
    this.router.navigate(['login-page'], { queryParams: { intent: 'fgpass' }, queryParamsHandling: 'merge' });
  }

  ahaBtn() {
    this.isLogIn = true;
    this.isSignUp = false;
    this.isForgotPasswd = false;
    this.angulartics2.eventTrack.next({ action: 'AlreadyHaveAccountClicked' });
    this.router.navigate(['login-page'], { queryParams: { intent: 'login' }, queryParamsHandling: 'merge' });
  }

  signUpRBtn() {
    this.isLogIn = false;
    this.isSignUp = true;
    this.isForgotPasswd = false;
    this.angulartics2.eventTrack.next({ action: 'DontHaveAccountRegiterClicked' });
    this.router.navigate(['login-page'], { queryParams: { intent: 'signup' }, queryParamsHandling: 'merge' });
  }

  onInternalSubmit(email, passwd) {
    this.sharedContainer.login(email, passwd);
  }

  goBack() {
    this.router.navigate(['../']);
  }

  forgotPasswd() {
    this.router.navigate(['login-page'], { queryParams: { intent: 'fgpass' } });
  }

  fbLogin() {
    this.stableSocialSignin('loginFacebook');
  }

  gLogin() {
    this.stableSocialSignin('loginGoogle');
  }

  restoreLogInSignUpInputs() {
    this.userEmail = null;
    this.userPasswd = null;
    this.userPasswdConfirm = null;
  }

  stablelogin(): void {
    if (this.isLoggedIn$) { return; }
    if (this.loginSuccess) { return; }
    this.spinner.show();
    this.basicAuth.login(this.userEmail, this.userPasswd)
      .subscribe(
        userInfo => {
          const loggedInUser: IUser = {
            email: userInfo['email'],
            id: userInfo['id'],
            name: userInfo['name'],
            surname: userInfo['surname'],
            username: userInfo['username']
          };
          this.isLoggedIn$ = true;
          this.sharedContainer.isLoggedIn$ = true;
          this.sharedContainer.userLoggedInSub.next(true);
          this.userLoggedInSub.next(true);
          this.userId = userInfo['id'];
          this.sharedContainer.userId = userInfo['id'];
          super.loginUser(loggedInUser);
          setTimeout(() => {
            if (this.afterFillingRequest) {
              this.loginSuccess = true;
              if (environment.production) {
                const allowed = this.getRequestExpiryCookie('expiryCookie');
                if (allowed !== null && allowed === false) {
                  alert('You recently sent a request. Please wait 10 minutes before sending one again!');
                  this.dashboardService.getLastRequestsByUserDesc(this.userId, 1).subscribe(data => {
                    this.spinner.hide();
                    if (data.length > 0) {
                      const fromDate = new Date(data[0].fromDate);
                      const toDate = new Date(data[0].toDate);
                      const fromDateFormatted = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate();
                      const toDateFormatted = toDate.getFullYear() + '-' + (toDate.getMonth() + 1) + '-' + toDate.getDate();
                      this.router.navigate(['results/'], {
                        queryParams: {
                          checkInDate: fromDateFormatted,
                          checkOutDate: toDateFormatted,
                          adults: data[0].noOfAdults,
                          children: data[0].noOfChildren,
                          'personalrequest': data[0].personalRequest,
                          'rooms': parseInt(data[0].noOfRooms, 10),
                          'requestId': parseInt(data[0].id, 10),
                          region: data[0].destination,
                          sortby: 'high_to_low'
                        }
                      });
                      this.restoreLogInSignUpInputs();
                    } else {
                      this.router.navigate(['search/']);
                      this.restoreLogInSignUpInputs();
                    }
                  });
                  return;
                }
              }
              this.requestForSearch.userid = this.userId;
              this.requestForSearch.fromdate = this.requestForSearch.checkInDate;
              this.requestForSearch.todate = this.requestForSearch.checkOutDate;
              this.searchService.sendRequests(this.requestForSearch).subscribe(requestId => {
                this.router.navigate(['results/'], {
                  queryParams: {
                    checkInDate: this.requestForSearch.checkInDate,
                    checkOutDate: this.requestForSearch.checkOutDate,
                    adults: this.requestForSearch.adults,
                    children: this.requestForSearch.children,
                    sendRequests: this.requestForSearch.sendRequests,
                    'experiences': this.requestForSearch.experiences,
                    'personalrequest': this.requestForSearch.personalrequest,
                    'rooms': parseInt(this.requestForSearch.rooms, 10),
                    sortby: 'high_to_low',
                    region: this.requestForSearch.region,
                    origin: this.sharedContainer.userCountry,
                    requestId: requestId
                  }
                });
                // Adwords Conversion
                if (environment.production) {
                  this.angulartics2.eventTrack.next({
                    action: 'sendrequest',
                    properties: { category: 'req_conversion' }
                  });
                }
                this.spinner.hide();
                this.setRequestExpiryCookie('expiryCookie', false, 600000);
              });
              this.spinner.hide();
              this.afterFillingRequest = false;
              this.restoreLogInSignUpInputs();
            } else {
              this.dashboardService.getLastRequestsByUserDesc(this.userId, 1).subscribe(data => {
                if (data.length > 0) {
                  const fromDate = new Date(data[0].fromDate);
                  const toDate = new Date(data[0].toDate);
                  const fromDateFormatted = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate();
                  const toDateFormatted = toDate.getFullYear() + '-' + (toDate.getMonth() + 1) + '-' + toDate.getDate();
                  this.spinner.hide();
                  this.router.navigate(['results/'], {
                    queryParams: {
                      checkInDate: fromDateFormatted,
                      checkOutDate: toDateFormatted,
                      adults: data[0].noOfAdults,
                      children: data[0].noOfChildren,
                      'personalrequest': data[0].personalRequest,
                      'rooms': parseInt(data[0].noOfRooms, 10),
                      'requestId': parseInt(data[0].id, 10),
                      region: data[0].destination,
                      accomtype: data[0].accommodationType,
                      dailybudget: data[0].priceRange,
                      origin: this.sharedContainer.userCountry,
                      sortby: 'high_to_low',
                      offers: 0
                    }
                  });
                  this.restoreLogInSignUpInputs();
                  // this.spinner.hide();
                } else {
                  this.spinner.hide();
                  this.router.navigate(['search/']);
                  this.restoreLogInSignUpInputs();
                }
              });
            }
          }, 2000);
        },
        (error) => {
          this.spinner.hide();
          console.log(error.error);
          alert(error.error);
        }
      );

  }

  stableSignUpNow(): void {

    const suBtn = <HTMLButtonElement>document.getElementById('button__signup');

    if (this.userPasswd === this.userPasswdConfirm) {
      this.userSignup.email = this.userEmail;
      this.userSignup.passwd = this.userPasswd;
      this.userSignup.name = this.userEmail;
      this.userSignup.surname = this.userEmail;

      this.spinner.show();

      if (!this.isLoggedIn$) {
        this.basicAuth.register(this.userSignup).subscribe(userInfo => {
          if (this.afterFillingRequest) {
            this.angulartics2.eventTrack.next({ action: 'UserSignUpFromFlow-RequestMandatory' });
          } else {
            this.angulartics2.eventTrack.next({ action: 'UserSignUpFromFlow-NoRequest' });
          }
          suBtn.remove();
          this.basicAuth.login(this.userSignup['email'], this.userSignup['passwd'])
            .subscribe(
              userInfoSU => {
                const loggedInUser: IUser = {
                  email: userInfoSU['email'],
                  id: userInfoSU['id'],
                  name: userInfoSU['name'],
                  surname: userInfoSU['surname'],
                  username: userInfoSU['username']
                };
                this.isLoggedIn$ = true;
                this.sharedContainer.isLoggedIn$ = true;
                this.sharedContainer.userLoggedInSub.next(true);
                this.userLoggedInSub.next(true);
                this.userId = userInfoSU['id'];
                this.sharedContainer.userId = userInfoSU['id'];
                super.loginUser(loggedInUser);
                if (this.afterFillingRequest) {
                  this.angulartics2.eventTrack.next({ action: 'RequestAfterSignUp' });
                  this.requestForSearch.userid = this.userId;
                  this.requestForSearch.fromdate = this.requestForSearch.checkInDate;
                  this.requestForSearch.todate = this.requestForSearch.checkOutDate;
                  this.searchService.sendRequests(this.requestForSearch).subscribe(requestId => {
                    this.router.navigate(['results/'], {
                      queryParams: {
                        checkInDate: this.requestForSearch.checkInDate,
                        checkOutDate: this.requestForSearch.checkOutDate,
                        adults: this.requestForSearch.adults,
                        children: this.requestForSearch.children,
                        sendRequests: this.requestForSearch.sendRequests,
                        'experiences': this.requestForSearch.experiences,
                        'personalrequest': this.requestForSearch.personalrequest,
                        'rooms': parseInt(this.requestForSearch.rooms, 10),
                        sortby: 'high_to_low',
                        region: this.requestForSearch.region,
                        origin: this.sharedContainer.userCountry,
                        requestId: requestId
                      }
                    });
                    // Adwords Conversion
                    if (environment.production) {
                      this.angulartics2.eventTrack.next({
                        action: 'sendrequest',
                        properties: { category: 'req_conversion' }
                      });
                    }
                    // this.spinner.hide();
                    this.setRequestExpiryCookie('expiryCookie', false, 600000);
                  });
                  this.afterFillingRequest = false;
                } else {
                  this.spinner.hide();
                  this.angulartics2.eventTrack.next({ action: 'BurgerSignUpSuccess' });
                  this.router.navigate(['search/']);
                }
              },
              (error) => {
                this.spinner.hide();
                console.log(error.error);
                alert(error.error);
              }
            );
        },
          (error) => {
            this.spinner.hide();
            console.log(error);
            alert('User already exists!');
          });
      }
    } else {
      alert('Passwords do not match!');
    }
  }

  stableSocialSignin(social) {

    this.angulartics2.eventTrack.next({ action: social + ' pressed' });

    if (social === 'loginFacebook') {
      this.auth.signIn(FacebookLoginProvider.PROVIDER_ID);
      this.auth.authState.subscribe((user) => {
        this.loggedIn = (user != null && user !== undefined);
        this.fbuser = user;
        if (this.loggedIn) {
          this.user = {
            email: this.fbuser.email,
            passwd: this.fbuser.id,
          };
          this.userEmail = this.fbuser.email;
          this.userPasswd = this.fbuser.id;
          this.stablelogin();
        }
      });
    } else if (social === 'loginGoogle') {
      this.auth.signIn(GoogleLoginProvider.PROVIDER_ID);
      this.auth.authState.subscribe((user) => {
        this.loggedIn = (user != null && user !== undefined);
        this.fbuser = user;
        if (this.loggedIn) {
          this.user = {
            email: this.fbuser.email,
            passwd: this.fbuser.id,
          };
          this.userEmail = this.fbuser.email;
          this.userPasswd = this.fbuser.id;
          this.stablelogin();
        }
      });
    }
  }

  stableSocialSignup(social) {
    this.angulartics2.eventTrack.next({ action: social + ' pressed' });
    if (social === 'signupFacebook') {
      this.auth.signIn(FacebookLoginProvider.PROVIDER_ID);
    } else if (social === 'signupGoogle') {
      this.auth.signIn(GoogleLoginProvider.PROVIDER_ID);
    }
    this.auth.authState.subscribe((user) => {
      this.fbuser = user;
      this.loggedIn = (user != null && user !== undefined);
      if (this.loggedIn && social === 'signupFacebook') {
        this.userEmail = this.fbuser.email;
        this.userPasswd = this.fbuser.id;
        this.userPasswdConfirm = this.fbuser.id;
        if (!this.fromSocialSignUp && this.userEmail.length > 4 && this.userPasswd.length > 5) {
          this.stableSignUpNow();
        }
        this.fromSocialSignUp = true;
        setTimeout(() => {
          this.fromSocialSignUp = false;
        }, 120000);

      } else if (this.loggedIn && social === 'signupGoogle') {
        this.userEmail = this.fbuser.email;
        this.userPasswd = this.fbuser.id;
        this.userPasswdConfirm = this.fbuser.id;
        if (!this.fromSocialSignUp && this.userEmail.length > 4 && this.userPasswd.length > 5) {
          this.stableSignUpNow();
        }
        this.fromSocialSignUp = true;
        setTimeout(() => {
          this.fromSocialSignUp = false;
        }, 120000);

      }
    });
  }

  signUpStableInit() {
    const re = /(?=.*\d)(?=.*[A-Z]).{6,}/;
    if (!re.test(this.userPasswd)) {
      this.showDetailsPasswd = true;
      return;
    }
    this.angulartics2.eventTrack.next({ action: 'NormalSignUp' });
    this.stableSignUpNow();
  }

  getRequestExpiryCookie(key) {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }

  setRequestExpiryCookie(key, value, ttl) {

    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  googleCallBack(): Observable<any> {
    const ur = `${environment.backendRoot}/webresources/frontend/entity.users/loginGoogle/`;
    const url = ur + encodeURIComponent(encodeURIComponent(JSON.stringify(this.requestForSearch)));
    return this.http.get(url,
      { headers: new HttpHeaders().set('Content-Type', 'application/json') }
    );
  }

  facebookCallBack(): Observable<any> {
    const ur = `${environment.backendRoot}/webresources/frontend/entity.users/loginFacebook/`;
    const url = ur + encodeURIComponent(encodeURIComponent(JSON.stringify(this.requestForSearch)));
    return this.http.get(url,
      { headers: new HttpHeaders().set('Content-Type', 'application/json') }
    );
  }

  socialSignIn(provider: String) {
    this.spinner.show();
    if (provider === 'google') {
      this.googleCallBack().subscribe((url) => {
        window.open(url[0], '_self');
      });
    } else if (provider === 'facebook') {
      this.facebookCallBack().subscribe((url) => {
        window.open(url[0], '_self');
      });
    }

    setTimeout(() => {
      window.alert('Something went wrong! Please try again in a while');
      this.spinner.hide();
    }, 15000);

  }

  handleProcessAfterAuth(loggedInUser: IUser) {

    this.spinner.show();

    this.isLoggedIn$ = true;
    this.sharedContainer.isLoggedIn$ = true;
    this.sharedContainer.userLoggedInSub.next(true);
    this.userLoggedInSub.next(true);
    this.userId = loggedInUser.id;
    this.sharedContainer.userId = loggedInUser.id;
    super.loginUser(loggedInUser);

    if (this.afterFillingRequest) {
      this.loginSuccess = true;
      if (environment.production) {
        const allowed = this.getRequestExpiryCookie('expiryCookie');
        if (allowed !== null && allowed === false) {
          alert('You recently sent a request. Please wait 10 minutes before sending one again!');
          this.dashboardService.getLastRequestsByUserDesc(this.userId, 1).subscribe(data => {
            this.spinner.hide();
            if (data.length > 0) {
              const fromDate = new Date(data[0].fromDate);
              const toDate = new Date(data[0].toDate);
              const fromDateFormatted = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate();
              const toDateFormatted = toDate.getFullYear() + '-' + (toDate.getMonth() + 1) + '-' + toDate.getDate();
              this.router.navigate(['results/'], {
                queryParams: {
                  checkInDate: fromDateFormatted,
                  checkOutDate: toDateFormatted,
                  adults: data[0].noOfAdults,
                  children: data[0].noOfChildren,
                  'personalrequest': data[0].personalRequest,
                  'rooms': parseInt(data[0].noOfRooms, 10),
                  'requestId': parseInt(data[0].id, 10),
                  region: data[0].destination,
                  sortby: 'high_to_low'
                }
              });
              // this.spinner.hide();
            } else {
              this.router.navigate(['search/']);
              this.spinner.hide();
            }
          });
          return;
        }
      }
      this.requestForSearch.userid = this.userId;
      this.requestForSearch.fromdate = this.requestForSearch.checkInDate;
      this.requestForSearch.todate = this.requestForSearch.checkOutDate;
      this.requestForSearch.origin = this.sharedContainer.userCountry;
      this.searchService.sendRequests(this.requestForSearch).subscribe(requestId => {
        this.router.navigate(['results/'], {
          queryParams: {
            checkInDate: this.requestForSearch.checkInDate,
            checkOutDate: this.requestForSearch.checkOutDate,
            adults: this.requestForSearch.adults,
            children: this.requestForSearch.children,
            sendRequests: this.requestForSearch.sendRequests,
            'experiences': this.requestForSearch.experiences,
            'personalrequest': this.requestForSearch.personalrequest,
            'rooms': parseInt(this.requestForSearch.rooms, 10),
            sortby: 'high_to_low',
            region: this.requestForSearch.region,
            requestId: requestId
          }
        });
        // Adwords Conversion
        if (environment.production) {
          this.angulartics2.eventTrack.next({
            action: 'sendrequest',
            properties: { category: 'req_conversion' }
          });
        }
        this.spinner.hide();
        this.setRequestExpiryCookie('expiryCookie', false, 600000);
      });
      this.spinner.hide();
      this.afterFillingRequest = false;
      this.restoreLogInSignUpInputs();
    } else {
      this.dashboardService.getLastRequestsByUserDesc(this.userId, 1).subscribe(data => {
        if (data.length > 0) {
          const fromDate = new Date(data[0].fromDate);
          const toDate = new Date(data[0].toDate);
          const fromDateFormatted = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate();
          const toDateFormatted = toDate.getFullYear() + '-' + (toDate.getMonth() + 1) + '-' + toDate.getDate();
          this.spinner.hide();
          this.router.navigate(['results/'], {
            queryParams: {
              checkInDate: fromDateFormatted,
              checkOutDate: toDateFormatted,
              adults: data[0].noOfAdults,
              children: data[0].noOfChildren,
              'personalrequest': data[0].personalRequest,
              'rooms': parseInt(data[0].noOfRooms, 10),
              'requestId': parseInt(data[0].id, 10),
              region: data[0].destination,
              sortby: 'high_to_low',
              offers: 0
            }
          });
          // this.spinner.hide();
        } else {
          this.spinner.hide();
          this.router.navigate(['search/']);
        }
      });
    }
  }

  playAnimationLogin() {

    const phone = gsap.timeline();
    const text = gsap.timeline();

    phone.fromTo('#browse_phone', { y: 250 }, { y: 0, duration: 1, opacity: 1, ease: 'elastic.out(1, 0.7)' });

    text.fromTo('#text-top', { y: 50, opacity: 0 }, { y: 0, opacity: 1, ease: 'elastic.out(1, 0.7)', delay: 0.5 });
    text.fromTo('#text-bot', { y: -50, opacity: 0 }, { y: 0, opacity: 1, ease: 'elastic.out(1, 0.7)' });

    phone.fromTo('#offer-1', { y: -50, opacity: 0 }, { y: 0, opacity: 1, ease: 'elastic.out(1, 0.7)', delay: 0.5 });
    phone.fromTo('#offer-2', { y: 50, opacity: 0 }, { y: 0, opacity: 1, ease: 'elastic.out(1, 0.7)' });
    phone.fromTo('#offer-3', { y: 50, opacity: 0 }, { y: 0, opacity: 1, ease: 'elastic.out(1, 0.7)' });
  }
}
